import { Api } from "@webapp/util/Api"
import { useTokenManager } from "@webapp/auth/TokenManager"
import { Environment } from "@webapp/util/Environment"
import { useGroupAdminNotifications } from "./GroupAdminNotifications"

export const gpUrl = Environment.get('GROUP_ADMIN_URL')

export function useGroupAdminApi(anonymous = false) {
    const tokenManager = useTokenManager()
    const { getConnectionId } = useGroupAdminNotifications()
    
    return anonymous
        ? new GroupAdminApi(gpUrl, () => '')
        : new GroupAdminApi(gpUrl, tokenManager.getAccessTokenAsync, () => getConnectionId() ?? '')
}

export class GroupAdminApi extends Api {
    constructor(baseUrl: string, 
        getToken?: () => Promise<string | undefined> | string | undefined,
        getPushConnectionId?: () => Promise<string | undefined> | string | undefined) {
        super(baseUrl, getToken, getPushConnectionId)
    }

    async appearReadyAsync(appId: string) {
        await this.postPlainAsync(`app/${appId}/ready`)
    }

    async getAppReadyAsync(appId: string) {
        const response = await this.getPlainAsync(`app/${appId}/ready`)
        return response.ready
    }
}
